var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18V19H18H5H4.17007L4.01713 18.1843L1.46124 4.55287C1.11507 2.70662 2.53144 1 4.40985 1H16C17.6569 1 19 2.34315 19 4V18Z",
    fill: "#CDAC87",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35H28.8299L28.9829 34.1843L34.5388 4.55287C34.8849 2.70662 33.4686 1 31.5901 1H14.4099C12.5314 1 11.1151 2.70663 11.4612 4.55287L17.0171 34.1843L17.1701 35H18H28Z",
    fill: "#EEE0D0",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.b84b01e6fb9534222a1d50111018796e.svg";
export { ForwardRef as ReactComponent };